import {Observable} from 'rxjs';

import {isSignal, Signal} from '@angular/core';
import {ActivatedRouteSnapshot, MaybeAsync, RouterStateSnapshot} from '@angular/router';

export type IDeactivatable = {
	canDeactivate: (() => MaybeAsync<boolean>) | Signal<boolean>;
	onDeactivate?: (currentRoute?: ActivatedRouteSnapshot, currentState?: RouterStateSnapshot, nextState?: RouterStateSnapshot, canDeactivateSelection?: boolean) => Observable<boolean>;
};

export function isDeactivatable(component: any): component is IDeactivatable {
	return component && (typeof component.canDeactivate === 'function' || isSignal(component.canDeactivate));
}
